module.exports = __webpack_public_path__ + "img/Medicine.aa695af1.svg";